import cx from "classnames";
import FieldWrapper from "../components/FieldWrapper";
import { ImageFieldType } from "../types/feedbackFields.types";
import { getImageSrc } from "../utils/image.utils";
import { FieldValueProps } from "./fields.types";
import { withSingleValue } from "./fields.utils";
import Images from "../utils/images";

// TODO: handle required
const ImageField = ({ field, value, error, onChange }: { field: ImageFieldType } & FieldValueProps<number>) => {
  const { _id, name, images, showTitle } = field;
  const id = _id || name;

  return (
    <FieldWrapper field={field} error={error}>
      <div style={{ display: "flex" }}>
        {(images || []).map((image, index) => (
          <div
            key={index}
            className={cx("smiley", { selected: value === index + 1 })}
            onClick={() => onChange(id, index + 1)}
          >
            <img
              src={Images.maxWidth(getImageSrc(image.image)!, 1000)}
              alt={image.text}
              style={{ height: 40, width: 40 }}
            />
            {showTitle && <p>{image.text}</p>}
          </div>
        ))}
      </div>
    </FieldWrapper>
  );
};
export default withSingleValue(ImageField);
